import gql from 'graphql-tag'
import { useState } from 'react'

import Statuses, { RequestStatus } from '@cinch/oxd-utils/request-status/src'

import client from './prismic-apollo-client'

import { GuideSummaryProps } from '@cinch/oxd-components/guide-summary/src/guide-summary.component'

const useSearch = () => {
  const [status, setStatus] = useState<RequestStatus>(Statuses.INITIAL)
  const [searchItems, setSearchItems] = useState<GuideSummaryProps[]>([])
  const [term, setTerm] = useState<string>('')
  const [totalItemsCount, setTotalItemsCount] = useState(0)

  const makeRequest = async (searchTerm: string) => {
    setStatus(Statuses.PENDING)
    setTerm(searchTerm)

    try {
      // fetch articles from cms
      const res = await client.query({
        query: gql`
          query GetArticles($searchTerm: String) {
            allArticles(fulltext: $searchTerm, first: 10, sortBy: meta_firstPublicationDate_DESC) {
              totalCount
              edges {
                node {
                  _meta {
                    uid
                    firstPublicationDate
                  }
                  lead_paragraph
                  title
                  main_image
                }
              }
            }
          }
        `,
        variables: { searchTerm },
      })

      // assignments
      const { totalCount, edges } = res.data.allArticles

      // format the response edges into article props
      const formattedItems = edges.map(
        ({
          node: {
            _meta: { uid, firstPublicationDate },
            lead_paragraph,
            title,
            main_image,
          },
        }: any) => ({
          id: uid,
          featured: false,
          headline: title,
          datePublished: firstPublicationDate,
          description: lead_paragraph[0].text,
          image: main_image && main_image.url,
        }),
      )

      setTotalItemsCount(totalCount)
      setSearchItems(formattedItems)
      setStatus(Statuses.SUCCESS)
    } catch (e) {
      setStatus(Statuses.ERROR)
    }

    return Promise.resolve()
  }

  return {
    status,
    searchItems,
    term,
    totalItemsCount,
    makeRequest,
  }
}

export default useSearch
